import { inject as service } from '@ember/service';
import Route from '@ember/routing/route';
import { EMBER_ROUTE_NAMES } from 'sh-www/constants/routes';

class SamlSigninRoute extends Route {
  /**
   * Register services
   */
  @service('local-storage-fallback') storage;
  @service session;
  @service router;

  /** @inheritDoc */
  async beforeModel() {
    await this.session.authenticate('authenticator:simple');

    if (this.session.isAuthenticated) {
      this.router.transitionTo(EMBER_ROUTE_NAMES.START);
    } else {
      this.router.transitionTo(EMBER_ROUTE_NAMES.SIGNIN);
    }
  }
}

export default SamlSigninRoute;
